import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Shared";
import { SERVICES } from "../../data/content";

export default function Footer({ onScrollTo }) {
  return (
    <footer className="relative border-t border-white/10 bg-[#060A14]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-sm leading-relaxed" style={{ color: "#94A3B8" }}>
              A3NETWORKS (OPC) Private Limited — a professionally managed telecom
              implementation and material supply company delivering end-to-end
              network infrastructure.
            </p>
            <a
              href="mailto:admin@a3networks.co.in"
              data-testid="footer-email"
              className="group mt-8 inline-flex items-center gap-2 font-display font-extrabold text-2xl md:text-3xl text-white tracking-tight hover:text-cyan transition-colors duration-300"
            >
              admin@a3networks.co.in
              <ArrowUpRight size={22} className="cta-arrow" />
            </a>
          </div>

          <div className="md:col-span-3">
            <span className="mono-label" style={{ color: "#64748B" }}>Services</span>
            <ul className="mt-5 space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => onScrollTo("services")}
                    className="text-sm hover:text-cyan transition-colors duration-300"
                    style={{ color: "#94A3B8" }}
                  >
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <span className="mono-label" style={{ color: "#64748B" }}>Reach Us</span>
            <div className="mt-5 space-y-4 text-sm" style={{ color: "#94A3B8" }}>
              <p className="leading-relaxed">
                Office No. 205, Building 61, Vijay Block,<br />Laxmi Nagar, Delhi – 110092
              </p>
              <a href="tel:01141604464" className="block hover:text-cyan transition-colors duration-300">011-41604464</a>
              <button
                onClick={() => onScrollTo("contact")}
                data-testid="footer-cta"
                className="group inline-flex items-center gap-2 border border-white/20 hover:border-cyan text-white px-5 py-3 mono-label transition-colors duration-300"
              >
                Request a Quote
                <ArrowUpRight size={15} className="cta-arrow" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="mono-label" style={{ color: "#64748B" }}>
            © {new Date().getFullYear()} A3NETWORKS (OPC) Private Limited
          </span>
          <div className="flex items-center gap-5">
            <a href="/portal/login" data-testid="footer-portal-link" className="mono-label hover:text-cyan transition-colors duration-300" style={{ color: "#64748B" }}>
              HR Portal
            </a>
            <span className="mono-label" style={{ color: "#64748B" }}>
              Telecom Infrastructure · Delhi, India
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
